export default "__VITE_ASSET__CGTrHvG2__"